export function getSiteEnv() {
  if (process.env.NODE_ENV === 'development') {
    return 'dev';
  }
  // 因为正式环境域名有多个，所以只能通过排除测试环境来判断
  const { hostname } = window.location;
  if (hostname.includes('ads-gray') || hostname.includes('test')) {
    return 'gray';
  }
  return 'prod';
}

export const SITE_ENV = getSiteEnv();
